export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/SylndrDealerIcon.9562bacc.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};